import { Box, Icon } from '@betterment/samba-react';

import { SambaAutoLink } from '../../../../../features/navigation/SambaAutoLink';

interface ActivityReportsUrlProps {
  url: string;
}

export const ActivityReportsUrl: React.FC<ActivityReportsUrlProps> = ({ url }) => {
  return (
    <Box css={{ pt: 'space.200' }}>
      <SambaAutoLink to={url}>
        <Box css={{ display: 'inline-flex', alignItems: 'center', gap: 'space.100' }}>
          <Icon name="DocumentPopulated" size="small" />
          View documents
        </Box>
      </SambaAutoLink>
    </Box>
  );
};
